import { layoutStyles } from "@/themes/layoutStyles";

export const styles = {
  dialogContent: {
    ...layoutStyles.scroll,
    width: "600px",
  },
};
